import { createApp } from "vue"
import { createRouter, createWebHistory } from "vue-router"
import App from "./App.vue"
import routes from "../router"
import Text from "./components/ui/Text.vue"

const router = createRouter({
	history: createWebHistory(),
	routes,
})

createApp(App).use(router).component("Text", Text).mount("#app")
